<template>
  <div class="submit-button__container white-back-container">
    <div class="white-back-container__content">
      <div
        v-if="isAlcoholItem"
        id="submit-button__container__over-twenty"
        class="submit-button__container__over-twenty"
      >
        <div
          v-if="showableOverTwentyCheckErrorMessage"
          class="error-message submit-button__container__over-twenty__error-message"
        >
          {{ overTwentyCheckErrorMessage }}
        </div>
        <div
          class="submit-button__container__over-twenty__checkbox"
          :class="{
            checkbox: !isOverTwenty,
            'checkbox--checked': isOverTwenty
          }"
          @click="onClickIsOverTwenty"
        >
          <input
            id="delivery_address_form_over_twenty_check"
            v-model="isOverTwenty"
            type="checkbox"
            name="delivery_address_form[over_twenty_check]"
            :class="{ field_with_errors: showableOverTwentyCheckErrorMessage }"
          />
          <label for="delivery_address_form_over_twenty_check">
            あなたは20歳以上ですか？
          </label>
        </div>
        <p
          class="submit-button__container__over-twenty__checkbox__minimal-info"
        >
          アルコール類の受け取りには、年齢制限があります
        </p>
      </div>
      <div class="submit-button__container__privacy-policy">
        <div
          v-if="showableAgreedPrivacyPolicyErrorMessage"
          class="error-message submit-button__container__privacy-policy__error-message"
        >
          個人情報の取扱いについての同意が必要です
        </div>
        <div
          class="submit-button__container__privacy-policy__checkbox"
          :class="{
            checkbox: !isAgreedPrivacyPolicy,
            'checkbox--checked': isAgreedPrivacyPolicy
          }"
          @click="onClickIsAgreedPrivacyPolicy"
        >
          <input
            id="delivery_address_form_agreed_privacy_policy"
            v-model="isAgreedPrivacyPolicy"
            type="checkbox"
            name="delivery_address_form[agreed_privacy_policy]"
            :class="{
              field_with_errors: showableAgreedPrivacyPolicyErrorMessage
            }"
          />
          <label class="submit-button__container__privacy-policy__label">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="/privacy_policy"
              class="submit-button__container__privacy-policy__link"
            ><!-- eslint-disable-line -->個人情報の取扱いについて</a>に同意する</label>
          <!-- TODO: ↑labelとaの改行でeslintとprettierのコンフリクトが起きたため一時的な回避 -->
        </div>
      </div>
      <div class="submit-button__container__button">
        <button
          :disabled="!isSubmittable"
          type="submit"
          class="btn btn--primary"
        >
          入力内容の確認
        </button>
      </div>
      <div class="minimal submit-minimal-info">
        お客様の情報はSSL暗号化通信によりセキュアに守られております
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isAgreedPrivacyPolicy: {
      type: Boolean,
      required: true
    },
    isOverTwenty: {
      type: Boolean,
      required: true
    },
    isAlcoholItem: {
      type: Boolean,
      required: false
    },
    overTwentyCheckErrorMessage: {
      type: String,
      required: true
    },
    showableAgreedPrivacyPolicyErrorMessage: {
      type: Boolean,
      required: true
    },
    isSubmittable: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      inputIsAgreedPrivacyPolicy: false,
      inputIsOverTwenty: false
    }
  },
  computed: {
    showableOverTwentyCheckErrorMessage() {
      return this.overTwentyCheckErrorMessage.length !== 0
    }
  },
  mounted() {
    this.inputIsAgreedPrivacyPolicy = this.isAgreedPrivacyPolicy
    this.inputIsOverTwenty = this.isOverTwenty
  },
  methods: {
    onClickIsAgreedPrivacyPolicy() {
      this.inputIsAgreedPrivacyPolicy = !this.inputIsAgreedPrivacyPolicy
      this.$emit(
        'change-is-agreed-privacy-policy',
        this.inputIsAgreedPrivacyPolicy
      )
    },
    onClickIsOverTwenty() {
      this.inputIsOverTwenty = !this.inputIsOverTwenty
      this.$emit('change-is-over-twenty', this.inputIsOverTwenty)
    }
  }
}
</script>
